module.exports = __webpack_public_path__ + "img/WMSlot.9ba85590.png";